<div class="main-vehicle-card">
  @if (vehicleInfo != null) {
    <!-- Banner de Cabecera -->
    <div class="vehicle-banner"></div>

    <!-- Contenedor del Perfil Flotante -->
    <div class="vehicle-profile-header">
      <div class="logo-container">
        @if (vehicleInfo.veh_url_photo) {
          <img [src]="vehicleInfo.veh_url_photo" alt="Foto Vehículo" class="vehicle-logo-img" />
        } @else {
          <div class="vehicle-logo-placeholder">
            <i class="pi pi-car text-white" style="font-size: 2.2rem;"></i>
          </div>
        }
      </div>
      <div class="vehicle-meta-info">
        <h2 class="vehicle-title">{{ vehicleInfo.veh_plate }}</h2>
        <p class="vehicle-description">
          <i class="pi pi-tag text-indigo-500 me-2"></i> {{ vehicleInfo.veh_brand }} {{ vehicleInfo.veh_model }} ({{ vehicleInfo.veh_color }})
        </p>
        <div class="d-flex gap-2 align-items-center mt-2 flex-wrap">
          <span class="status-badge status-active">
            <i class="pi pi-check-circle me-1"></i> {{ vehicleInfo.veh_status == 1 ? 'Activo en Flota' : 'Inactivo' }}
          </span>
          @if (vehicleInfo.veh_inspection === 1) {
            <span class="status-badge verification-badge">
              <i class="pi pi-verified me-1"></i> Inspección OK
            </span>
          }
          @if (vehicleInfo.veh_secure === 1) {
            <span class="status-badge verification-badge">
              <i class="pi pi-shield me-1"></i> Seguro Activo
            </span>
          }
        </div>
      </div>
    </div>

    <!-- Pestañas de Detalle -->
    <p-tabView>
      
      <!-- Pestaña 1: Ficha Técnica y Conductor -->
      <p-tabView>
        <p-tabPanel header="Datos del Vehículo">
          <div class="row">
            <!-- Columna Izquierda: Ficha Técnica e Inspección -->
            <div class="col-12 col-md-7">
              <!-- Tarjeta 1: Ficha Técnica -->
              <div class="detail-card">
                <h3 class="detail-card-title">
                  <i class="pi pi-car"></i> Especificaciones Técnicas
                </h3>
                
                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-indigo">
                        <i class="pi pi-ticket"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Placa / Matrícula</div>
                        <p class="info-value font-bold text-indigo-700" style="letter-spacing: 0.5px;">{{ vehicleInfo.veh_plate }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-blue">
                        <i class="pi pi-bookmark"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Número de Registro</div>
                        <p class="info-value">{{ vehicleInfo.veh_num_registration }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6 mb-3">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-purple">
                        <i class="pi pi-tags"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Marca & Modelo</div>
                        <p class="info-value font-bold">{{ vehicleInfo.veh_brand }} {{ vehicleInfo.veh_model }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mb-3">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-orange">
                        <i class="pi pi-calendar"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Año de Fabricación</div>
                        <p class="info-value">{{ vehicleInfo.veh_anio }}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-gray">
                        <i class="pi pi-palette"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Color Extendido</div>
                        <p class="info-value">{{ vehicleInfo.veh_color }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="info-row">
                      <div class="info-icon-wrapper icon-indigo">
                        <i class="pi pi-users"></i>
                      </div>
                      <div class="info-content">
                        <div class="info-label">Capacidad de Ocupantes</div>
                        <p class="info-value">{{ vehicleInfo.veh_quantity_person }} Asientos autorizados</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tarjeta 2: Conductor Asignado -->
              <div class="detail-card mt-3">
                <div class="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                  <h3 class="detail-card-title m-0 border-0 p-0">
                    <i class="pi pi-user"></i> Conductor Asignado
                  </h3>
                  <p-button
                    label="Cambiar Conductor"
                    icon="pi pi-user-edit"
                    [rounded]="true"
                    [text]="true"
                    severity="primary"
                    (onClick)="changeDriverVehicle()"
                  />
                </div>

                @if (vehicleInfo.veh_dri_id === 0 || !vehicleInfo.dri_name) {
                  <div class="text-center py-4">
                    <i class="pi pi-user-minus text-muted mb-2" style="font-size: 2rem;"></i>
                    <p class="text-secondary m-0">Sin conductor asignado a esta unidad de servicio.</p>
                  </div>
                } @else {
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="info-row">
                        <div class="info-icon-wrapper icon-emerald">
                          <i class="pi pi-id-card"></i>
                        </div>
                        <div class="info-content">
                          <div class="info-label">Nombre Completo</div>
                          <p class="info-value font-bold">{{ vehicleInfo.dri_name }} {{ vehicleInfo.dri_last_name }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="info-row">
                        <div class="info-icon-wrapper icon-blue">
                          <i class="pi pi-verified"></i>
                        </div>
                        <div class="info-content">
                          <div class="info-label">Licencia del Conductor</div>
                          <p class="info-value">{{ vehicleInfo.dri_number_license || 'No registrada' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>

            <!-- Columna Derecha: Foto de Perfil del Vehículo -->
            <div class="col-12 col-md-5 d-flex align-items-stretch">
              <div class="detail-card w-100 d-flex flex-column align-items-center justify-content-center text-center">
                <h3 class="detail-card-title w-100 text-start">
                  <i class="pi pi-image"></i> Fotografía del Vehículo
                </h3>
                <div class="logo-container my-4" style="width: 240px; height: 180px; border-radius: 12px;">
                  @if (vehicleInfo.veh_url_photo) {
                    <p-image 
                      [src]="vehicleInfo.veh_url_photo" 
                      alt="Foto de la Flota" 
                      width="240" 
                      [preview]="true"
                      imageClass="vehicle-logo-img rounded"
                      [style]="{ 'object-fit': 'cover' }"
                    ></p-image>
                  } @else {
                    <div class="vehicle-logo-placeholder" style="border-radius: 12px; font-size: 4rem;">
                      <i class="pi pi-car"></i>
                    </div>
                  }
                </div>
                <p class="text-muted small mt-2">Haz clic sobre la imagen para expandir y visualizar detalles físicos</p>
              </div>
            </div>
          </div>
        </p-tabPanel>

        <!-- Pestaña 2: Documentación del Coche -->
        <p-tabPanel header="Documentos del Vehículo">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h4 class="m-0 font-semibold text-color">Expediente Legal del Vehículo</h4>
              <p class="text-secondary small m-0">Matrículas, inspecciones técnicas, pólizas de seguros y contratos del coche</p>
            </div>
            <p-button 
              (onClick)="dialogNewFile()" 
              label="Agregar Documento" 
              icon="pi pi-plus" 
              severity="primary"
              [rounded]="true"
            />
          </div>

          <p-dataView #dv [value]="vehicleInfo.lstDocument">
            <ng-template pTemplate="list" let-documents>
              <div class="row mt-2">
                <div class="col-12 col-md-6" *ngFor="let doc of documents">
                  <div class="doc-item-card d-flex align-items-center gap-3">
                    <div class="doc-icon-wrapper">
                      @if (doc.doc_extension === 'png' || doc.doc_extension === 'jpg' || doc.doc_extension === 'jpeg') {
                        <i class="pi pi-image"></i>
                      } @else {
                        <i class="pi pi-file"></i>
                      }
                    </div>
                    <div class="doc-meta">
                      <div class="doc-title">{{ doc.typ_name }}</div>
                      <div class="doc-subtitle">{{ doc.doc_name || 'Archivo legal' }}</div>
                    </div>
                    <div class="d-flex gap-2">
                      <p-button
                        icon="pi pi-download"
                        [rounded]="true"
                        [text]="true"
                        pTooltip="Descargar"
                        tooltipPosition="top"
                        (onClick)="downloadFile(doc.doc_route, doc.doc_name)"
                      />
                      <p-button
                        icon="pi pi-trash"
                        [rounded]="true"
                        [text]="true"
                        severity="danger"
                        pTooltip="Eliminar"
                        tooltipPosition="top"
                        (onClick)="deleteFile(doc)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-dataView>
        </p-tabPanel>
      </p-tabView>

    </p-tabView>
  }
</div>

<!-- Modal: Agregar Documento al Vehículo -->
<p-dialog
  header="Cargar Documento al Vehículo"
  [modal]="true"
  [(visible)]="newFile"
  [style]="{ width: '40rem' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="custom-dialog"
>
  <div class="p-3">
    <div class="logo-upload-box p-4 text-center mb-4">
      <p-fileUpload
        #fileUpload
        mode="basic"
        chooseLabel="Seleccionar Archivo"
        chooseIcon="pi pi-upload"
        [showUploadButton]="false"
        [showCancelButton]="false"
        maxFileSize="7340032"
        (onSelect)="onUploadAuto($event.files, fileUpload)"
        accept="image/png,image/jpeg,application/pdf"
        [multiple]="false"
        styleClass="p-button-outlined p-button-indigo"
      >
      </p-fileUpload>
      <p class="text-secondary small mt-2 mb-0">Imágenes (PNG, JPG) o PDFs legales de hasta 7MB</p>
    </div>

    <div class="mb-4">
      <label class="form-label-edit mb-2 d-block">Tipo de Documentación</label>
      <p-dropdown
        [options]="ltsTypeDocument"
        [(ngModel)]="selectedTypeDocument"
        optionLabel="typ_name"
        placeholder="Seleccione el tipo de documento"
        styleClass="largeInput"
        [appendTo]="'body'"
      />
    </div>

    @if (ltsDocument.length > 0) {
      <div class="detail-card p-3 mb-4">
        <h5 class="font-semibold text-color mb-3 small uppercase tracking-wider">Archivo Listo para Cargar</h5>
        <p-table [value]="ltsDocument">
          <ng-template pTemplate="header">
            <tr>
              <th id="th-pre">Vista</th>
              <th id="th-name">Nombre</th>
              <th id="th-type">Tipo</th>
              <th id="th-act" style="width: 4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-doc let-index="rowIndex">
            <tr>
              <td>
                @if (doc.filstring) {
                  <p-image [src]="doc.filstring" alt="Previsualizar" width="40" height="40" imageClass="rounded border shadow-sm" [style]="{ 'object-fit': 'cover' }"></p-image>
                } @else {
                  <i class="pi pi-file text-indigo-500" style="font-size: 1.5rem"></i>
                }
              </td>
              <td class="text-truncate" style="max-width: 150px;">{{ doc.file.name }}</td>
              <td>{{ doc.typeDocument.typ_name }}</td>
              <td>
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (onClick)="removeFile(index)"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2 pt-2 border-top">
      <p-button label="Cancelar" [outlined]="true" severity="secondary" (onClick)="closeNewFile()" />
      <p-button label="Cargar Archivo" severity="primary" [disabled]="ltsDocument.length === 0" (onClick)="saveFile()" />
    </div>
  </ng-template>
</p-dialog>

<!-- Modal: Cambiar Conductor del Vehículo -->
<p-dialog
  header="Cambiar Conductor Asignado"
  [modal]="true"
  [(visible)]="changeDriver"
  [style]="{ width: '32rem' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="custom-dialog"
>
  <div class="p-3">
    <p class="text-secondary small mb-4">Seleccione uno de los conductores disponibles (sin vehículo asignado actualmente) para asociar a esta unidad.</p>
    
    <div class="mb-4">
      <label class="form-label-edit mb-2 d-block">Conductores Disponibles</label>
      <p-dropdown
        [options]="lstDriver"
        optionLabel="dri_full_name"
        [filter]="true"
        filterBy="dri_full_name"
        [showClear]="false"
        placeholder="Seleccione un conductor"
        [appendTo]="'body'"
        [(ngModel)]="selectedDriver"
        styleClass="largeInput"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption>
          <div class="d-flex align-items-center gap-2">
            <i class="pi pi-user text-indigo-500"></i>
            <div>{{ selectedOption.dri_full_name }}</div>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <div class="d-flex align-items-center gap-2">
            <i class="pi pi-user text-secondary"></i>
            <div>{{ option.dri_full_name }} (Lic: {{ option.dri_number_license || 'S/N' }})</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2 pt-2 border-top">
      <p-button label="Cancelar" [outlined]="true" severity="secondary" (onClick)="closeChangeDriver()" />
      <p-button label="Confirmar Asignación" severity="primary" [disabled]="!selectedDriver" (onClick)="saveChangeDriver()" />
    </div>
  </ng-template>
</p-dialog>
